import { isNil } from 'lodash';

export const getEmailHasChanged = (
  currentEmail: string | null | undefined,
  summonsEmail: string | null | undefined,
): boolean => {
  if (isNil(currentEmail) || isNil(summonsEmail)) {
    return false;
  }
  return currentEmail !== summonsEmail;
};

export function getSummonsOutdated(
  emailSummonsId: string | null | undefined,
  summonsDocId: string | null | undefined,
): boolean {
  if (isNil(summonsDocId)) {
    return false;
  }
  return emailSummonsId !== summonsDocId;
}
